import { render } from "./GeeTestCaptcha.vue?vue&type=template&id=091b8241&scoped=true"
import script from "./GeeTestCaptcha.vue?vue&type=script&lang=js"
export * from "./GeeTestCaptcha.vue?vue&type=script&lang=js"

import "./GeeTestCaptcha.vue?vue&type=style&index=0&id=091b8241&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091b8241"]])

export default __exports__